"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const emotion_0_svg_1 = __importDefault(require("./assets/old/emotion_0.svg"));
const emotion_1_svg_1 = __importDefault(require("./assets/old/emotion_1.svg"));
const emotion_2_svg_1 = __importDefault(require("./assets/old/emotion_2.svg"));
const emotion_3_svg_1 = __importDefault(require("./assets/old/emotion_3.svg"));
const emotion_4_svg_1 = __importDefault(require("./assets/old/emotion_4.svg"));
const emotion_0_checked_svg_1 = __importDefault(require("./assets/old/emotion_0_checked.svg"));
const emotion_1_checked_svg_1 = __importDefault(require("./assets/old/emotion_1_checked.svg"));
const emotion_2_checked_svg_1 = __importDefault(require("./assets/old/emotion_2_checked.svg"));
const emotion_3_checked_svg_1 = __importDefault(require("./assets/old/emotion_3_checked.svg"));
const emotion_4_checked_svg_1 = __importDefault(require("./assets/old/emotion_4_checked.svg"));
const emotion_0_svg_2 = __importDefault(require("./assets/portal/emotion_0.svg"));
const emotion_1_svg_2 = __importDefault(require("./assets/portal/emotion_1.svg"));
const emotion_2_svg_2 = __importDefault(require("./assets/portal/emotion_2.svg"));
const emotion_3_svg_2 = __importDefault(require("./assets/portal/emotion_3.svg"));
const emotion_4_svg_2 = __importDefault(require("./assets/portal/emotion_4.svg"));
const hrdsAssets_1 = require("./hrdsAssets");
const emotionsMap = {
    1: 'angry',
    2: 'sad',
    3: 'neutral',
    4: 'smile',
    5: 'laugh'
};
const emotionAssetsMap = {
    hrds: [
        { asset: hrdsAssets_1.emotionHrds0 },
        { asset: hrdsAssets_1.emotionHrds1 },
        { asset: hrdsAssets_1.emotionHrds2 },
        { asset: hrdsAssets_1.emotionHrds3 },
        { asset: hrdsAssets_1.emotionHrds4 }
    ],
    // eslint-disable-next-line camelcase
    old_style: [
        { asset: emotion_0_svg_1.default, checkedAsset: emotion_0_checked_svg_1.default },
        { asset: emotion_1_svg_1.default, checkedAsset: emotion_1_checked_svg_1.default },
        { asset: emotion_2_svg_1.default, checkedAsset: emotion_2_checked_svg_1.default },
        { asset: emotion_3_svg_1.default, checkedAsset: emotion_3_checked_svg_1.default },
        { asset: emotion_4_svg_1.default, checkedAsset: emotion_4_checked_svg_1.default }
    ],
    portal: [
        { asset: emotion_0_svg_2.default },
        { asset: emotion_1_svg_2.default },
        { asset: emotion_2_svg_2.default },
        { asset: emotion_3_svg_2.default },
        { asset: emotion_4_svg_2.default }
    ]
};
function getEmotionAssets(preset) {
    const emotions = emotionAssetsMap[preset];
    if (!emotions) {
        return '';
    }
    return Object.keys(emotionsMap).map((key) => {
        const id = Number(key);
        const emotion = emotionsMap[id];
        const { asset: baseAsset, checkedAsset } = emotions[id - 1];
        return (0, react_1.css) `
        .emotion__option_${emotion} {
          background-image: url(${baseAsset});
        }
        ${checkedAsset
            ? `.emotion__container_checked .emotion__option_${emotion} {
                background-image: url(${checkedAsset});
            }
            .emotion__container:hover .emotion__option_${emotion} {
                background-image: url(${checkedAsset});
            }`
            : ''}
      `;
    });
}
exports.default = getEmotionAssets;
